import { render } from "./EditDiscovery.vue?vue&type=template&id=60b8eef7&scoped=true"
import script from "./EditDiscovery.vue?vue&type=script&lang=js"
export * from "./EditDiscovery.vue?vue&type=script&lang=js"

import "./EditDiscovery.vue?vue&type=style&index=0&id=60b8eef7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b8eef7"]])

export default __exports__